import InfiniteSearchableSelect from '../../../components/ui/SearchableSelect/InfiniteSearchableSelect';
import LicenseSearchableSelect from './LicenseSearchableSelect';
import { fetchLicenseProfileListPage } from '../adapters/licenseProfileListAdapter';
import { mapProfileToSelectOption } from '../adapters/profileListAdapter';

const isSameProfile = (a, b) => String(a?.id) === String(b?.id);
const getProfileId = (option) => option?.id;
const getProfileLabel = (profile) => profile?.label || profile?.name || '';

export default function LicenseProfileSearchableSelect({
  valueId = null,
  onChange,
  selectedProfile = null,
  enabled = true,
  pageSize = 20,
  ...props
}) {
  return (
    <InfiniteSearchableSelect
      {...props}
      fetchPage={fetchLicenseProfileListPage}
      pageSize={pageSize}
      enabled={enabled}
      valueId={valueId}
      selectedSeed={selectedProfile}
      mapToOption={mapProfileToSelectOption}
      isSameOption={isSameProfile}
      getOptionId={getProfileId}
      getOptionLabel={getProfileLabel}
      isOptionEqualToValue={isSameProfile}
      onChange={onChange}
      SelectComponent={LicenseSearchableSelect}
    />
  );
}
